import { Edge, MarkerType } from '@xyflow/react'
import { DomainIntegrationProviders } from '@pushly/models/lib/enums/domain-integration-providers'
import { JourneyEdge } from './types/journey-nodes'

export const EDGE_ID_PREFIX = 'eid-'
export const DEFAULT_CUSTOM_EDGE_CONFIG: Partial<Edge<JourneyEdge>> = {
    type: 'custom',
    markerEnd: {
        type: MarkerType.ArrowClosed,
        width: 8,
        color: '#75808a',
    },
}

export const MIN_VERTICAL_SPACING = 60
export const MIN_NODE_HEIGHT = 60

export const RECOMMENDATION_NOTIFICATION_INTEGRATIONS = [DomainIntegrationProviders.BLUECONIC_REC]
